
const ContactInfo = () => {
  return (
    <div>
      <h2 className="text-3xl md:text-4xl font-bold text-graphite mb-6">
        Contacta con Nosotros
      </h2>
      
      <p className="text-lg text-gray-dark leading-relaxed mb-8">
        En JUSTCLEAN Castelldefels estamos comprometidos con ofrecerte el mejor servicio de vaciado de pisos, locales y limpieza extrema. Contacta con nosotros por el medio que prefieras y te responderemos lo antes posible.
      </p>

      <div className="space-y-6 mb-10">
        <a
          href="tel:+34602365996"
          className="flex items-start space-x-4 p-4 bg-silver-light/30 rounded-xl hover:bg-silver-light/50 transition-colors cursor-pointer"
        >
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="ri-phone-line text-white text-xl"></i>
          </div>
          <div>
            <h3 className="font-semibold text-graphite mb-1">Teléfono</h3>
            <p className="text-primary font-semibold text-lg">602 36 59 96</p>
            <p className="text-sm text-gray-medium">Disponible 24/7</p>
          </div>
        </a>

        <a
          href="mailto:info@castelldefels.justclean.es"
          className="flex items-start space-x-4 p-4 bg-silver-light/30 rounded-xl hover:bg-silver-light/50 transition-colors cursor-pointer"
        >
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="ri-mail-line text-white text-xl"></i>
          </div>
          <div>
            <h3 className="font-semibold text-graphite mb-1">Email</h3>
            <p className="text-primary font-semibold">info@castelldefels.justclean.es</p>
            <p className="text-sm text-gray-medium">Respuesta en 24h</p>
          </div>
        </a>

        <div className="flex items-start space-x-4 p-4 bg-silver-light/30 rounded-xl">
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="ri-map-pin-line text-white text-xl"></i>
          </div>
          <div>
            <h3 className="font-semibold text-graphite mb-1">Dirección</h3>
            <p className="text-gray-dark">Passeig Marítim 234</p>
            <p className="text-gray-dark">08860 Castelldefels, Barcelona</p>
          </div>
        </div>

        <div className="flex items-start space-x-4 p-4 bg-silver-light/30 rounded-xl">
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <i className="ri-time-line text-white text-xl"></i>
          </div>
          <div>
            <h3 className="font-semibold text-graphite mb-1">Horario</h3>
            <p className="text-gray-dark">Lunes a Domingo: 24 horas</p>
            <p className="text-sm text-gray-medium">Incluidos festivos</p>
          </div>
        </div>
      </div>

      <div className="bg-primary/5 rounded-2xl p-6">
        <h3 className="font-bold text-graphite mb-3">Garantías de Servicio</h3>
        <ul className="space-y-2">
          <li className="flex items-center text-gray-dark">
            <i className="ri-checkbox-circle-fill text-primary mr-2"></i>
            <span>Presupuesto Gratis y Sin Compromiso</span>
          </li>
          <li className="flex items-center text-gray-dark">
            <i className="ri-checkbox-circle-fill text-primary mr-2"></i>
            <span>Respuesta Inmediata</span>
          </li>
          <li className="flex items-center text-gray-dark">
            <i className="ri-checkbox-circle-fill text-primary mr-2"></i>
            <span>Máxima Discreción</span>
          </li>
          <li className="flex items-center text-gray-dark">
            <i className="ri-checkbox-circle-fill text-primary mr-2"></i>
            <span>Servicio Profesional Garantizado</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ContactInfo;
